module.exports = __webpack_public_path__ + "static/img/reference pics_cgu university2.469864f4.jpg";